export default __webpack_public_path__ + "static/media/3d_cube.3a202f16.png";